export class EventBus {
  constructor() {
    this.listeners = new Map()
    // this.enableConsole()
  }

  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set())
    }
    this.listeners.get(event).add(callback)
  }

  once(event, callback) {
    const wrapper = (...args) => {
      this.off(event, wrapper)
      callback(...args)
    }
    this.on(event, wrapper)
  }

  off(event, callback) {
    const handlers = this.listeners.get(event)
    if (handlers) {
      handlers.delete(callback)
      if (handlers.size === 0) {
        this.listeners.delete(event)
      }
    }
  }

  emit(event, ...args) {
    const handlers = this.listeners.get(event)
    if (handlers) {
      handlers.forEach((handler) => {
        try {
          handler(...args)
        } catch (error) {
          console.error(`[eventBus] Error in "${event}" handler:`, error)
        }
      })
    }

    this.logToConsole(event, args)
  }

  // For debugging: render events to a small console in the DOM
  enableConsole() {
    if (document) {
      const container = document.createElement('div')
      container.id = 'event-log-console'
      Object.assign(container.style, {
        position: 'fixed',
        bottom: 0,
        right: 0,
        width: '400px',
        maxHeight: '200px',
        overflowY: 'auto',
        background: '#111',
        color: '#0f0',
        fontSize: '12px',
        padding: '10px',
        zIndex: 9999,
        fontFamily: 'monospace',
      })
      document.body.appendChild(container)
      this.consoleElement = container
    }
  }

  logToConsole(event, args) {
    const logText = `[${new Date().toLocaleTimeString()}] ${event}: ${JSON.stringify(args[0])}`
    console.log(logText)
    if (!this.consoleElement) return
    const log = document.createElement('div')
    log.textContent = logText
    this.consoleElement.prepend(log)
    if (this.consoleElement.children.length > 100) {
      this.consoleElement.removeChild(this.consoleElement.lastChild)
    }
  }
}

export const eventBus = new EventBus()
